var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C6.17879 0 2.71351 2.10432 0.15649 5.52231C-0.0521632 5.80233 -0.0521632 6.19355 0.15649 6.47358C2.71351 9.89568 6.17879 12 10 12C13.8212 12 17.2865 9.89568 19.8435 6.47769C20.0522 6.19767 20.0522 5.80645 19.8435 5.52642C17.2865 2.10432 13.8212 0 10 0ZM10.2741 10.2251C7.73755 10.3857 5.64284 8.2814 5.80239 5.72409C5.93331 3.61565 7.63118 1.90666 9.72589 1.77488C12.2625 1.61428 14.3572 3.7186 14.1976 6.27591C14.0626 8.38023 12.3647 10.0892 10.2741 10.2251ZM10.1473 8.27316C8.78081 8.35964 7.65163 7.22718 7.74164 5.85175C7.81119 4.71517 8.72763 3.79684 9.85681 3.72272C11.2233 3.63624 12.3525 4.7687 12.2625 6.14413C12.1888 7.28483 11.2724 8.20316 10.1473 8.27316Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eyeIcon.8465fa64.svg";
export { ForwardRef as ReactComponent };